import React from "react";
import { ItemList } from "../../../../list/ItemList";
import { getDocumentIcon } from "../../../../../utils/documentUtils";
import { useNavigate } from "react-router-dom";

export const PaperDocList = ({ documents }) => {
    const navigate = useNavigate();

    const handleOpenDocument = (doc) => {
        navigate(`${doc.orgId ? `/org/${doc.orgId}` : `/vessels/${doc.vesselId}`}/documents/paper/${doc.id}`);
    };

    return (
        <ItemList bordered onItemClick={handleOpenDocument}>
            {documents?.map((doc, index) => (
                <ItemList.Item key={index} value={doc} type="paper" prepend={getDocumentIcon("paper")}>
                    {doc.title}
                </ItemList.Item>
            ))}
        </ItemList>
    );
};
